export const GENERIC_ERROR_MESSAGE = "Something went wrong. Please try again later";

// Basic Info
export const INVALID_NAME_ERROR_MESSAGE = "Invalid name: Must be 2-30 characters long and only contain letters, spaces, hyphens (-), and single quote (')";
export const INVALID_EMAIL_ERROR_MESSAGE = "Email invalid. Try using another email.";
export const NOT_ALLOWED_NAME_REGEX = /[^a-zA-Z'\s-]/g;

// Verify Identity
export const VALID_SSN_LENGTH = 9;
export const INVALID_SSN_ERROR_MESSAGE = "A valid SSN is required";
export const INVALID_DOB_ERROR_MESSAGE = "A valid date of birth is required";
export const VALID_AGE = 18;
export const INVALID_AGE_ERROR_MESSAGE = "Applicant must be over 18 years of age";
export const FAILED_SSN_SAVE_ERROR_MESSAGE = "There was an error with submitting your SSN, please try again.";
export const RE_ENTER_PROMPT = "Looks like might have miskeyed your SSN. Please try submitting again.";

// LinkBankV2
export const AGGREGATOR_TYPE_FINICITY = "Finicity";
export const AGGREGATOR_TYPE_PLAID = "Plaid";
export const CURRENT_DDA_FLOOR = `$1000`;
export const DDA_ACCOUNTS = ["checking", "savings"];
export const PLAID_EVENT_TYPES = {
  ERROR: "ERROR",
  EXIT: "EXIT",
  SELECT_INSTITUTION: "SELECT_INSTITUTION",
  SUBMIT_CREDENTIALS: "SUBMIT_CREDENTIALS",
  HANDOFF: "HANDOFF",
};
export const EXISTING_ACCOUNT_BUTTON_TEXT = "+ Add another";
export const NO_ACCOUNT_BUTTON_TEXT = "+ Add account";
export const ADD_ACCOUNTS_ERROR_MESSAGE = "We're having trouble adding your bank accounts. Please try again later.";
export const FETCH_ACCOUNTS_ERROR_MESSAGE = "We're having trouble fetching your newly added accounts. Please try again later.";
export const FETCH_ACCOUNTS_RELINK_ERROR_MESSAGE = "We're having trouble re-linking your accounts. Please try again later.";
export const REMOVE_ACCOUNTS_ERROR_MESSAGE = "We're having trouble removing your account. Please try again later.";